<template>
  <div class="prueba">
    <NavbarMain />
    <SliderCustom />
    <FooterComp />
  </div>
</template>

<script>


export default {
  name: "PruebaView",

  data() {
    return {};
  },

  components: {

  },

  created: function() {},

  methods: {
    verPromo: function() {},
  },
};
</script>
